import accordionList from './js/old/accordionList';
import './scss/old-acf-blocks/accordionlist.scss';

accordionList();
